<div class="modal-header">
  <label class="col-form-label" style="font-weight: bold;">Mantenimiento de artículos</label>
  <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close " aria-label="Close" (click)="cerrar()"
    style="outline: none;" tabindex="13">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="row">

  <!-- <div class="col-md-12"> -->
  <div class="col-lg-12">
    <br>
    <div [hidden]="vista !== 1" class=" col-md-3">
      <button type="button" class="btn btn-rounded btn-success m-b-5" (click)="verInsertar()"><i class="fa fa-plus"></i>
        Nuevo </button>
    </div>

    <div [hidden]="vista !== 2">
      <!-- <button type="button" class="btn btn-rounded btn-info m-b-15"
            (click)="guardar()" tabindex="13"><i class="fa fa-save"></i>
            Guardar </button>
          <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="cancelar()"
            (keydown.tab)="onNexFocus(vista === 2 ? 'nuevo' : 'modificar')" tabindex="14"><i class="fa fa-times-circle"></i>
            Cancelar </button> -->
    </div>
    <!--
        <div [hidden]="vista !== 3">
          <button type="button" class="btn btn-rounded btn-info m-b-15"
            (click)="guardarPlanCuenta('modificar')" tabindex="28"><i class="fa fa-save"></i>
            Guardar
          </button>
          <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="cancelarInsercion()"
            (keydown.tab)="onNexFocus(vista === 3 ? 'nuevo' : 'modificar')" tabindex="29"><i class="fa fa-times-circle"></i>
            Cancelar </button>
        </div> -->


    <div class="card">
      <div class="card-body">
        <div [hidden]="vista !== 1">
          <div>
            <!--  <h4 class="card-title">Plan cuentas:</h4> -->
            <!-- <div class="card-header card-header-modific">
                <div class="row">
                    <label class="col-form-label" style="font-weight: bold;">Mantenimiento de artículos</label>
                </div>
               </div> -->
            <div class="form-group row" style="margin-top: 5px;">
              <!-- <label for="fname2" class="col-md-2 text-left control-label col-form-label">Destino:
                      </label> -->
              <div class="col-md-12">

                <div class="form-group row d-flex align-items-center" style="margin-bottom: 0;">

                  <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Tipo de inventario:
                  </label>
                  <div class="col-sm-1" style="margin-left:-45px">
                    <input style="text-align: center;" (change)="onBlurTipodeInventario1($event)"
                      class="focus-input input_border form-control tsiInput" [(ngModel)]="buscar_tipinv"
                      name="inputtipiv" maxlength="2" type="text"
                      onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                  </div>

                  <div class="col-sm-3">
                    <select id="cboTipoInventario" tabindex="1" [(ngModel)]="buscar_tipinv"
                      (change)="onBlurTipodeInventario1($event)" name="cobTipoInventario" #selectTipoInventario
                      class="col-sm-12 tsiSelect  select_border">
                      <option *ngFor="let lst of tiposInventario " [value]="lst.tipinv">
                        {{lst.tipinv+' - '+lst.dtipinv}}
                      </option>
                    </select>
                  </div>
                  <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                </div>


                <div class="form-group row d-flex align-items-center" style="margin-bottom: 0;">

                  <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Artículo:
                  </label>

                  <div class="col-sm-2" style="margin-left:-45px">
                    <input id="inputarticulocodigo" type="text" class="focus-input input_border form-control tsiInput"
                      name="codArticulo" [(ngModel)]="buscar_codart" tabindex="12"
                      (keydown.enter)="onKeyEnterCodigoArticulo($event)" placeholder="Código..." maxlength="40">
                  </div>

                  <div class="input-group col-md-8">

                    <input id="desarticulo" type="text" class="form-control tsiInput col-md-9" name="desarticulo"
                      [(ngModel)]="buscar_descri" tabindex="2" #desarticulo (keydown.enter)="onKeyEnterArticulo($event)"
                      placeholder="Buscar articulo" maxlength="99">
                    <div class="input-group-append " style="width:40px">
                      <button *ngIf="buscarArticulo == 'buscar' " class="btn btn-primary btn-sm boton"
                        (click)="openModalArticulo()" type="button" tabindex="3"><i class=" fa fa-search"></i></button>
                      <button *ngIf="buscarArticulo == 'borrar'" class="btn btn-primary btn-sm boton"
                        (click)="borrarDatosArticulo()" type="button" tabindex="3"><i class="fas fa-times"></i></button>
                    </div>
                  </div>

                </div>
              </div>

            </div>

            <div class="table-responsive" style="height:60vh;">
              <table class="table table-sm table-striped table-bordered table-hover" style="margin-bottom: 15px;">
                <thead>
                  <tr>
                    <th class="registerAlign"></th>
                    <th class="registerAlign"> Código </th>
                    <th class="registerAlign"> Descripción </th>
                    <th class="registerAlign"> Unidad medida </th>
                    <th class="registerAlign">Cod. Fabricante</th>
                    <th class="registerAlign">Aplicacion/Comentario</th>
                    <th class="registerAlign">Cod. OEM</th>
                    <th class="registerAlign" *ngIf="listaNueva.length>0 && clasesDefinidas>=6 && listaNueva[5].desclase !=''
                          && listaNueva[5].swacti =='S'">{{listaNueva[5].desclase}}</th>
                    <th class="registerAlign" *ngIf="listaNueva.length>0 && clasesDefinidas>=4 && listaNueva[3].desclase !=''
                                && listaNueva[3].swacti =='S'">{{listaNueva[3].desclase}}</th>
                    <th class="registerAlign" *ngIf="listaNueva.length>0 && clasesDefinidas>=5 && listaNueva[4].desclase !=''
                            && listaNueva[4].swacti =='S'">{{listaNueva[4].desclase}}</th>
                    <th class="registerAlign" *ngIf="listaNueva.length>0 && clasesDefinidas>=1 && listaNueva[0].desclase !=''
                          && listaNueva[0].swacti =='S' ">{{listaNueva[0].desclase}}</th>
                    <th class="registerAlign" *ngIf="listaNueva.length>0 && clasesDefinidas>=2 && listaNueva[1].desclase !=''
                            && listaNueva[1].swacti =='S' ">{{listaNueva[1].desclase}}</th>
                    <th class="registerAlign" *ngIf="listaNueva.length>0 && clasesDefinidas>=3 && listaNueva[2].desclase !=''
                            && listaNueva[2].swacti =='S'">{{listaNueva[2].desclase}}</th>
                    <th class="registerAlign">Activo</th>
                  </tr>

                </thead>
                <tbody>
                  <tr *ngFor="let lst of articulos" (click)="onClick(lst)"
                    [ngClass]="{'nombre-de-la-clase': lst == this.itemtemp}">

                    <td scope="row" style="display: table-cell; text-align: center; padding-bottom: 0px; "
                      class="registerAlign">
                      <div class="btn-group btn-group-xs" role="group" style="margin: 0px;padding: 0px;"><button
                          type="button" class="btn btn-sm" style=" border: none; outline: none;" (click)="abrirModificar(lst)"><span class="fas fa-pencil-alt"
                            aria-hidden="true"></span></button>
                      </div>
                    </td>
                    <td class="registerAlign"> {{lst.codart}}</td>
                    <td class="registerAlign">{{lst.descri}}</td>
                    <td class="registerAlign">{{lst.coduni}}</td>
                    <td class="registerAlign">{{lst.proart}}</td> <!-- CODIGO FABRICANTE -->
                    <td class="registerAlign text-wrap">{{lst.wglosa}}</td> <!-- APLICACION COMENTARIO -->
                    <td class="registerAlign">{{lst.codoem}}</td> <!-- CODIGO OEM -->

                    <td class="registerAlign text-wrap"
                      *ngIf="listaNueva.length>0 && clasesDefinidas>=6 && listaNueva[5].desclase !='' && listaNueva[5].swacti =='S'">
                      {{lst.descla6}}</td>
                    <td class="registerAlign text-wrap"
                      *ngIf="listaNueva.length>0 && clasesDefinidas>=4 && listaNueva[3].desclase !='' && listaNueva[3].swacti =='S'">
                      {{lst.descla4}}</td>
                    <td class="registerAlign text-wrap"
                      *ngIf="listaNueva.length>0 && clasesDefinidas>=5 && listaNueva[4].desclase !='' && listaNueva[4].swacti =='S'">
                      {{lst.descla5}}</td>
                    <td class="registerAlign text-wrap"
                      *ngIf="listaNueva.length>0 && clasesDefinidas>=1 && listaNueva[0].desclase !='' && listaNueva[0].swacti =='S'">
                      {{lst.descla1}}</td>
                    <td class="registerAlign text-wrap"
                      *ngIf="listaNueva.length>0 && clasesDefinidas>=2 && listaNueva[1].desclase !='' && listaNueva[1].swacti =='S'">
                      {{lst.descla2}}</td>
                    <td class="registerAlign text-wrap"
                      *ngIf="listaNueva.length>0 && clasesDefinidas>=3 && listaNueva[2].desclase !='' && listaNueva[2].swacti =='S'">
                      {{lst.descla3}}</td>
                    <!-- <td style="text-align: center;">
                            <label class="ui-checkbox">
                                <input disabled type="checkbox"
                                    [checked]="lst.codcla9 == '0' ? false : true">
                                <span class="input-span"></span>
                            </label>
                        </td> -->
                    <td style="vertical-align: middle;">                      
                      <div style="text-align: center" *ngIf="lst.codcla9 == '1'">
                        <i class="fas fa-check fa-lg" style="color: green;"></i>
                      </div>
                      <div style="text-align: center;" *ngIf="lst.codcla9 != '1'">
                        <i class="fas fa-times fa-lg" style="color: red;"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p style="color:black;font-weight:bolder; font-size:large;"> Solo se muestran 100 primeros registros</p>
          </div>
        </div>

        <div [hidden]="vista !== 2">


        </div>

        <div [hidden]="vista != 3">

        </div>
      </div>
    </div>

  </div>
</div>